import {
  profile,
  loggedIn,
  loggedTaxis,
  axiosInst,
} from "../credentials.js";
import { CookiesApi } from "../utils/helpers";
import { logout } from "../auth.js";
import { get, set } from 'svelte/store';
import {
  loggedFromClient,
  logging_out,
  userDocuments,
  userDetails
} from "../ui-store.js";

export const findRelatedProtocolFromInstanceTags = async (organizationId, processInstanceId) => {
  // return new Promise(async (resolve, reject) => {
    try {
      let url = "open1process/" + organizationId + "/processes/instances/" + processInstanceId + "/tags";
      const res = await get(axiosInst).get(url);
      console.log(res, url);
      if (res.status === 200) {
        console.log(
          "findRelatedProtocolFromInstanceTags successful call",
          res.data.data
        );
        let relatedProtocolRefTag = res.data.data.find(tag => tag.toLowerCase().includes("dataversedocref"));
        let result = relatedProtocolRefTag == undefined ? null : relatedProtocolRefTag.split(":")[1];
        console.log(result);
        return(result);
      } else {
        alert("findRelatedProtocolFromInstanceTags :: something went wrong", res);
        throw new Error("findRelatedProtocolFromInstanceTags :: something went wrong", res);
      }
    } catch (err) {
      console.log("findRelatedProtocolFromInstanceTags fetch Error :-S", err);
      throw new Error(err);
    }
  // });
}

export const findRelatedGroupIdFromInstanceTags = async (organizationId, processInstanceId) => {
  // return new Promise(async (resolve, reject) => {
    try {
      let url = "open1process/" + organizationId + "/processes/instances/" + processInstanceId + "/tags";
      const res = await get(axiosInst).get(url);
      console.log(res, url);
      if (res.status === 200) {
        console.log(
          "findRelatedGroupIdFromInstanceTags successful call",
          res.data.data
        );
        let relatedGroupIdTag = res.data.data.find(tag => tag.toLowerCase().includes("dataversegroupid"));
        let result = relatedGroupIdTag == undefined ? null : relatedGroupIdTag.split(":")[1];
        console.log(result);
        return(result);
      } else {
        alert("findRelatedGroupIdFromInstanceTags :: something went wrong", res);
        throw new Error("findRelatedGroupIdFromInstanceTags :: something went wrong", res);
      }
    } catch (err) {
      console.log("findRelatedGroupIdFromInstanceTags fetch Error :-S", err);
      throw new Error(err);
    }
  // });
}

export const findRelatedUserIdFromInstanceTags = async (organizationId, processInstanceId) => {
  // return new Promise(async (resolve, reject) => {
    try {
      let url = "open1process/" + organizationId + "/processes/instances/" + processInstanceId + "/tags";
      const res = await get(axiosInst).get(url);
      console.log(res, url);
      if (res.status === 200) {
        console.log(
          "findRelatedUserIdFromInstanceTags successful call",
          res.data.data
        );
        let relatedUserIdTag = res.data.data.find(tag => tag.toLowerCase().includes("dataverseuserid"));
        let result = relatedUserIdTag == undefined ? null : relatedUserIdTag.split(":")[1];
        console.log(result);
        return(result);
      } else {
        alert("findRelatedUserIdFromInstanceTags :: something went wrong", res);
        throw new Error("findRelatedUserIdFromInstanceTags :: something went wrong", res);
      }
    } catch (err) {
      console.log("findRelatedUserIdFromInstanceTags fetch Error :-S", err);
      throw new Error(err);
    }
  // });
}


//Enter an external entity Email and find the Entity's Id
export const getEntityByEmail = async (taxId) => {
  return new Promise(async (resolve, reject) => {
    try {
      let url = "externalEntities/byTax";
      const res = await get(axiosInst).get(url, {
        params: { entityTaxId: taxId },
      });
      if (res.status === 200) {
        console.log("getEntityByEmail successful call", res.data);

        resolve(res.data);
      } else {
        alert("getEntityByEmail :: something went wrong", res);
        reject();
      }
    } catch (e) {
      console.log(e);
      reject(e);
    }
  });
};

//Get data about a registered organization
export const getRegisteredOrganizationData = async (clientId) => {
  return new Promise(async (resolve, reject) => {
    try {
      let url = "registeredOrganization/" + clientId;
      const res = await get(axiosInst).get(url);
      if (res.status === 200) {
        console.log(
          "getRegisteredOrganizationData successful call",
          res.data.data
        );

        resolve(res.data.data);
      } else {
        alert("getRegisteredOrganizationData :: something went wrong", res);
        reject();
      }
    } catch (e) {
      console.log(e);
      reject(e);
    }
  });
};

//See if a user's email belongs to a user group
export const getIfEmailBelongstoGroup = async (
  orgId,
  email,
  taxId,
  groupType
) => {
  return new Promise(async (resolve, reject) => {
    try {
      let url =
        "open1process/" +
        orgId +
        "/userGroups/emailBelongsToUserGroup?userEmail=" +
        email +
        "&afm=" +
        taxId +
        "&userGroupType=" +
        groupType;
      const res = await get(axiosInst).get(url);
      if (res.status === 200) {
        console.log("getIfEmailBelongstoGroup successful call", res.data.data);

        resolve(res.data.data);
      } else {
        alert("getIfEmailBelongstoGroup :: something went wrong", res);
        reject();
      }
    } catch (e) {
      console.log(e);
      reject(e);
    }
  });
};

//Upload a new file and relate it with process and possible element into the process
export const uploadFileIntoProcess = async (formData) => {
  return new Promise(async (resolve, reject) => {
    try {
      let url = "open1process/files";
      const res = await get(axiosInst).post(url, formData, {
        transformRequest: (formData, headers) => {
          return formData;
        },
      });
      if (res.status === 200) {
        console.log("uploadFileIntoProcess successful call", res.data.data);

        resolve(res.data.data);
      } else {
        alert("uploadFileIntoProcess :: something went wrong", res);
        reject();
      }
    } catch (e) {
      console.log(e);
      reject(e);
    }
  });
};

//duplicate an already existing file and relate it with process and possible element into the process
export const duplicateFileIntoProcess = async (orgId, issuerQuintuplet, duplicateFromFileId) => {
  return new Promise(async (resolve, reject) => {
    try {
      let url = "open1process/files/duplicate?" + 
        "orgUUId=" +
        issuerQuintuplet.split(":")[0] +
        "&orgStructureUUId=" +
        issuerQuintuplet.split(":")[1] +
        "&orgUnitUUId=" +
        issuerQuintuplet.split(":")[2] + 
        "&roleUUId=" +
        issuerQuintuplet.split(":")[3] +
        "&personUUId=" +
        issuerQuintuplet.split(":")[4] +
        "&duplicateFromFileId=" + 
        duplicateFromFileId +
        "&registeredOrganizationId=" +  
        orgId;
      const res = await get(axiosInst).post(url, {});
      if (res.status === 200) {
        console.log("duplicateFile successful call", res.data.data);

        resolve(res.data.data);
      } else {
        alert("duplicateFile :: something went wrong", res);
        reject();
      }
    } catch (e) {
      console.log(e);
      reject(e);
    }
  });
};

//Associate a proccess instance with an external entity and create new request
export const createNewUserRequest = async (userRequestContextDTO) => {
  return new Promise(async (resolve, reject) => {
    try {
      let url = "externalEntities/createRequest";
      const res = await get(axiosInst).post(url, userRequestContextDTO);
      if (res.status === 200) {
        console.log("createNewUserRequest successful call", res.data);

        resolve();
      } else {
        alert("createNewUserRequest :: something went wrong", res);
        reject();
      }
    } catch (e) {
      console.log(e);
      reject(e);
    }
  });
};

//Start a new process instance
export const startNewProcessInstance = async (request_body, setBKey,entranceBKey) => {
  return new Promise(async (resolve, reject) => {
    try {
      let url = "open1process/processes/start";
      const res = await get(axiosInst).post(url, request_body);
      if (res.status === 200) {
        console.log("startNewProcessInstance successful call", res.data);

        if (res.data.errors.length > 0) {
          console.log("An error occured" + ": " + res.data.errors);
          // add more actions...
          reject("something went wrong");
        } else {
          //no errors, move to next and final step
          console.log("Success!");
          //resolved.processId = res.data.data[0].instanceId;
          //resolves sending the object with process instance Id, and businesskey (whiich includes onnBehalf's name)
          let resolved_object = {
            resolved_processId: res.data.data[0].instanceId,
            resolved_bkey: null,
          };
          //if bkey vars are set, save request with them
          //also remove onBehalf's name from bkey, since it's only useful in process
          if (setBKey) resolved_object.resolved_bkey = entranceBKey;
          resolve(resolved_object);
        }
      } else {
        alert("startNewProcessInstance :: something went wrong", res);
        reject("something went wrong");
      }
    } catch (e) {
      console.log(e);
      reject(e);
    }
  });
};

//Get an external entity
export const getExternalEntity = async (entityId) => {
  return new Promise(async (resolve, reject) => {
    try {
      let url = "externalEntities/" + entityId;
      const res = await get(axiosInst).get(url);
      if (res.status === 200) {
        console.log("getExternalEntity successful call", res.data.data);

        if (res.data.errors.length > 0) {
          console.log("Error" + ": " + res.data.errors);
          // add more actions...
          reject();
        } else {
          //no errors, move to next and final step
          console.log("Success!");
          userDetails.set(Object.values(res.data.data.additionalInfoDTO));
          userDocuments.set(res.data.data.userDocuments);
          resolve(res.data.data);
        }
      } else {
        alert("getExternalEntity :: something went wrong", res);
        reject("something went wrong");
      }
    } catch (e) {
      console.log(e);
      reject(e);
    }
  });
};

//Validate an email verification token
export const validateEmailVerificationToken = async (email, token) => {
  return new Promise(async (resolve, reject) => {
    try {
      let url = "verification/verify";
      const res = await get(axiosInst).post(url, {
        email: email,
        token: token,
      });
      if (res.status === 200) {
        console.log(
          "validateEmailVerificationToken successful call",
          res.data.data
        );

        if (res.data.errors.length > 0) {
          console.log("Error" + ": " + res.data.errors);
          // add more actions...
          reject("something went wrong");
        } else {
          //no errors, move to next and final step
          console.log("Success!");

          resolve(res.data.data);
        }
      } else {
        alert("validateEmailVerificationToken :: something went wrong", res);
        reject("something went wrong");
      }
    } catch (e) {
      console.log(e);
      reject(e);
    }
  });
};

//Request for an email validation
export const requestEmailValidation = async (
  email,
  physicalEntityDTO,
  legalEntityDTO
) => {
  return new Promise(async (resolve, reject) => {
    try {
      let url = "verification/";
      const res = await get(axiosInst).post(url, {
        email: email,
        physicalEntityDTO: physicalEntityDTO,
        legalEntityDTO: legalEntityDTO,
      });
      if (res.status === 200) {
        console.log("requestEmailValidation successful call", res.data.data);

        if (res.data.errors.length > 0) {
          console.log("Error" + ": " + res.data.errors);
          // add more actions...
          reject();
        } else {
          //no errors, move to next and final step
          console.log("Success!");

          resolve();
        }
      } else {
        alert("requestEmailValidation :: something went wrong", res);
        reject();
      }
    } catch (e) {
      console.log(e);
      reject(e);
    }
  });
};

//Get a user group info
export const getUserGroup = async (orgId, userGroupIssuer) => {
  return new Promise(async (resolve, reject) => {
    try {
      let url =
        "open1process/" + orgId + "/userGroups/group/" + userGroupIssuer;
      const res = await get(axiosInst).get(url);
      if (res.status === 200) {
        console.log("getUserGroup successful", res.data.data);
        resolve(res.data.data);
      } else {
        alert("getUserGroup error", res);
        reject();
      }
    } catch (e) {
      console.log(e);
      reject(e);
    }
  });
};

//force logout from anonymous service page and reload
export const logoutForAnonymousService = (clientId, serviceId) => {
  let answer = confirm("Η υπηρεσία που επιλέξατε έχει επισημανθεί ως Ανώνυμη.\nΘα πραγματοποιηθεί αποσύνδεση. Θέλετε να συνεχίσετε;");
  if (answer) {
    logging_out.set(true);
    loggedIn.set(false);
    loggedTaxis.set(false);
    let orgUuid = get(loggedFromClient);
    profile.set(null);
    userDocuments.set([]);
    localStorage.removeItem("clientGsisId");
    localStorage.removeItem("GSISClientName");
    localStorage.removeItem("loggedFromClient");
    localStorage.removeItem("loggedFromClientName");
    CookiesApi.remove("gsisAuth", { path: "/" });
    CookiesApi.remove("sessionCookie", { path: "/" });
    //clientGsisId.useLocalStorage();
    //log the event first
    logEntranceLogout()
      .then(() => {
        // forces reload
        return logout(clientId,serviceId);
        // $goto("/client/:id/action/:aid/user/unregistered/new", { id: orgUuid, aid: serviceId });
        //history.pushState({}, null, 'http://localhost:9999/');
        // $goto("/");
      });
  }
  else {
    //if user wishes to not proceed, redirect them to client welcome page
    window.location.href = '/client/'+ clientId + '/welcome';
  }
};

const logEntranceLogout = () => {
  return new Promise(async (resolve, reject) => {
    try {
      await get(axiosInst)
        .get("externalEntities/logEntranceLogout")
        .then(function (response) {
          if (response.status === 200) {
            //If status OK, see if we have errors
            console.log(res.data);
            if (response.data.errors && response.data.errors.length > 0) {
              console.log("An error occured" + ": " + response.data.errors);
              //logout anyway
              resolve();
            } else {
              //no errors
              console.log("log event success");
              //no errors, remove sessionId
              resolve();
            }
          } else {
            console.log("something went wrong");
            //logout anyway
            resolve();
          }
        });
    } catch (err) {
      console.log("Fetch Error :-S", err);
      resolve();
    }
  });
};

export const matchUserProfileVariablesToRequest = (request_inputs, onBehalfOfDTO) => {
  console.log("running matches...", request_inputs, onBehalfOfDTO);
  request_inputs.forEach(input => {
    let target = get(userDetails).find( d => d.id == input.mapToVariableName);
    if (target && !input.inputvalue) {
      input.inputvalue = target.value;
    }
  });
  //also update onBehalfOfDTO's phone number 
  let phoneNumberInfo = get(userDetails).find( d => d.id == "thl");
  if (phoneNumberInfo && phoneNumberInfo.value) {
      onBehalfOfDTO.phoneNumber = phoneNumberInfo.value;
    }
  let result = {
    inputsArray: request_inputs,
    onBehalfOfDTO: onBehalfOfDTO
  };
  return result;

}
